// The ONE call every header Search button makes (channel, DM, agent session, DM with an agent).
// The scope is the place the button sits in; the agreed contract with the scoped top search is
// openScopedSearch({ kind, id }). Until that lands, this focuses the top search unscoped (the
// same thing Mod+F does): swap the body below for `openScopedSearch(scope)` and nothing else moves.
import { openScopedSearch } from "./scoped-search.svelte.js";

export interface HeaderSearchScope {
  kind: "channel" | "dm" | "agent";
  id: string;
}

let focusTopSearch: (() => void) | null = null;

// The top search (MessageSearch) registers how to focus itself while it is mounted.
export function registerTopSearch(focus: () => void): () => void {
  focusTopSearch = focus;
  return () => {
    if (focusTopSearch === focus) focusTopSearch = null;
  };
}

export function openHeaderSearch(scope: HeaderSearchScope): void {
  // openScopedSearch opens the top bar pre-scoped (in:<place> chip) via scopedSearch.request;
  // the focus call is the fallback for when the bar is not mounted to consume that request.
  openScopedSearch(scope);
  focusTopSearch?.();
}
